import { LoyaltyRewardMiniCardVariant } from "./types";

export const ContentLoyaltyRewardMiniCard = {
  [LoyaltyRewardMiniCardVariant.NOMINAL]: {
    title: "loyalty.cardReward.cashBonus.title",
    descriptionActive: "loyalty.cardReward.cashBonus.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.FREE_SPINS]: {
    title: "loyalty.cardReward.fs.title",
    descriptionActive: "loyalty.mini-card.free-spin.description.1",
  },
  [LoyaltyRewardMiniCardVariant.CASHBACK_DAILY]: {
    title: "loyalty.cardReward.dailyCashback.title",
    descriptionActive: "loyalty.cardReward.dailyCashback.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.CASHBACK_WEEKLY]: {
    title: "loyalty.cardReward.weeklyCashback.title",
    descriptionActive: "loyalty.cardReward.weeklyCashback.subtitle",
  },
  [LoyaltyRewardMiniCardVariant.CASHBACK_MONTHLY]: {
    title: "loyalty.cardReward.monthlyCashback.title",
    descriptionActive: "loyalty.cardReward.monthlyCashback.subtitle",
  },
};
